var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkCurso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83366 9.79159V8.16659H2.79199C1.89453 8.16659 1.16699 8.89412 1.16699 9.79159M3.76699 11.4166H8.10033C8.70705 11.4166 9.01041 11.4166 9.24215 11.2985C9.44599 11.1946 9.61172 11.0289 9.71558 10.8251C9.83366 10.5933 9.83366 10.29 9.83366 9.68325V2.31659C9.83366 1.70986 9.83366 1.4065 9.71558 1.17476C9.61172 0.97092 9.44599 0.805191 9.24215 0.701328C9.01041 0.583252 8.70705 0.583252 8.10033 0.583252H3.76699C2.85691 0.583252 2.40186 0.583252 2.05426 0.760366C1.74849 0.916161 1.4999 1.16475 1.34411 1.47052C1.16699 1.81812 1.16699 2.27317 1.16699 3.18325V8.81659C1.16699 9.72667 1.16699 10.1817 1.34411 10.5293C1.4999 10.8351 1.74849 11.0837 2.05426 11.2395C2.40186 11.4166 2.85691 11.4166 3.76699 11.4166Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkCurso);
export default __webpack_public_path__ + "static/media/link-curso.7277ab14e8d9c71cd3e7b0fbaa64d762.svg";
export { ForwardRef as ReactComponent };